import React from 'react';
import { bool, func, string } from 'prop-types';
import useStyles from 'hooks/useStyles';
import cx from 'classnames';

import useScrollIntoSelected from 'hooks/useScrollIntoSelected';

import styles from './Chapter.scss';

function Chapter({ isSelected, isDropDown, onClick, timestamp, description }) {
  useStyles(styles);
  const chapterRef = useScrollIntoSelected(isSelected);

  return (
    <li
      role="option"
      aria-selected={isSelected}
      className={cx(styles.item, {
        [styles.active]: isSelected,
        [styles.dropDown]: isDropDown,
      })}
      onClick={onClick}
      ref={chapterRef}
    >
      <div className={styles.timestamp}>{timestamp}</div>
      <div className={styles.description}>{description}</div>
    </li>
  );
}

Chapter.propTypes = {
  isSelected: bool.isRequired,
  isDropDown: bool.isRequired,
  onClick: func.isRequired,
  timestamp: string.isRequired,
  description: string.isRequired,
};

export default Chapter;
